import { combineReducers } from "redux";

import blog from "../features/components/blogs/blog/Slice";

import common from "../features/components/common/Slice";

const blogs = combineReducers({
    blog,
    common
});

export default blogs;